var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-body login"},[_c('v-card',{class:'login__box'},[_c('v-card-title',{class:'login__box-gc'},[_c('img',{attrs:{"src":require("../..//assets/gamechanger-logo-purple.svg"),"alt":"Gamechanger"}})]),_vm._v(" You are not authorised to access this area of the system. ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }